/* @flow */

import _ from 'lodash';

const deepEqualsUpdate = (props, nextProps) => (!_.isEqual(props, nextProps));

export default deepEqualsUpdate;
